import { INFO_CARD_STYLE_SCHEMA, normalizeInfoCardProps } from './infoCardProps';
import { siteValuesFromDocument } from '../../theme/styleSchema';

/**
 * Box « Carte info » du document → props du bloc web `InfoCard`.
 *
 * Les props COMMUNES de la box sont recopiées telles quelles : c'est tout
 * l'intérêt de les stocker aux noms de props du site. Ce qui n'appartient
 * qu'au document (couleurs de départ des textes) reste sur place. Seuls le
 * texte (Draft → HTML) et l'alignement (chrome du document → props du bloc)
 * demandent une traduction, et les deux sont injectés par l'appelant — ce
 * module ne connaît ni Draft.js ni le parser.
 *
 * @param {object} box box du document (`content.card`, `content.*Raw`)
 * @param {(raw: string) => string} toHtml conversion Draft brut → HTML
 * @param {{ horizontal: string, vertical: string }} positions alignement résolu
 * @returns {object} props du bloc, prêtes à poser dans le web_data
 */
export function infoCardPropsFromBox(box, { toHtml, positions }) {
  // Filtre volontairement étroit : la box porte aussi des réglages propres au
  // document (couleurs de départ des textes). Seules les props communes
  // traversent, converties s'il le faut (cf. le schéma).
  const style = box?.content?.card;
  const shared = siteValuesFromDocument(INFO_CARD_STYLE_SCHEMA, style);
  const resolved = normalizeInfoCardProps(shared);

  return {
    ...resolved,
    // `value` est le nom historique du titre côté web : une prop de bloc web
    // ne se renomme pas (README webviewer §4). Le document, lui, l'appelle
    // `title`, ce qu'il est.
    value: toHtml(box?.content?.titleRaw) || '',
    description: toHtml(box?.content?.descriptionRaw) || '',
    alignHorizontal: positions?.horizontal || resolved.alignHorizontal,
    alignVertical: positions?.vertical || resolved.alignVertical,
  };
}

/**
 * Une carte sans titre NI description n'a que son illustration à montrer : on
 * la garde quand même si elle en a une, sinon le parser l'ignore.
 */
export function isEmptyInfoCardProps(props) {
  if (props.value.trim() || props.description.trim()) return false;
  if (props.illustration === 'icon' && props.icon) return false;
  if (props.illustration === 'image' && props.imageUrl) return false;
  return true;
}
